import { momentFormat as de } from "./de.momentFormat";
import { momentFormat as en } from "./en.momentFormat";
export const CoreMomentFormat: object = { "de": de, "en": en };
